import React, { useEffect } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import moment from 'moment';
import { IPartnerRatingByPartnerUgo, IRealEstateRatingByPartnerUgo } from '../../../interfaces';
import { INomenclature } from '../interfaces';
import { useGetApplicationsByPartnerUgo } from '../hooks';

interface IProps extends Omit<DialogProps, 'onClose'> {
  partnerRating: IPartnerRatingByPartnerUgo;
  realEstateRating: IRealEstateRatingByPartnerUgo | null;
  nomenclature: INomenclature;
  onClose(): void;
}

const ApplicationsByPartnerDialog = ({
  open,
  partnerRating,
  realEstateRating,
  nomenclature,
  onClose,
  ...props
}: IProps) => {
  const { fetchApplicationsByPartnerUgo, loading, data, error, success } = useGetApplicationsByPartnerUgo();

  const params = {
    partnerGuid: partnerRating.smrPartnerGuid,
    realEstateGuid: realEstateRating?.realEstateGuid,
    nomenclaturaGuid: nomenclature.nomenclaturaGuid,
    year: moment(realEstateRating?.dateAt).year(),
    month: moment(realEstateRating?.dateAt).month() + 1,
  };
  const mapKey = Object.values(params).filter(Boolean).join('-');

  useEffect(() => {
    if (!open) return;
    fetchApplicationsByPartnerUgo(partnerRating.smrPartnerGuid, realEstateRating?.realEstateGuid!, {
      params,
    });
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const applications = data.get(mapKey) || [];

  return (
    <Dialog {...props} open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>Заявки по партнеру</DialogTitle>

      <DialogContent>
        {loading ? (
          <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
            <CircularProgress />
          </Box>
        ) : Boolean(error) ? (
          <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
            <Typography component="h3" variant="h4" align="center">
              {error}
            </Typography>
          </Box>
        ) : (
          success && (
            <>
              {Boolean(data) ? (
                <Table size="small" style={{ tableLayout: 'fixed' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Номер заявки</TableCell>
                      <TableCell align="center">Оценка</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {applications.map(({ applicationNumber, ratingSum }, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>
                            <Link href={`/application/${applicationNumber}`} target="_blank" color="textSecondary">
                              {applicationNumber}
                            </Link>
                          </TableCell>

                          <TableCell align="center">{ratingSum}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              ) : (
                <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
                  <Typography component="h3" variant="h4" align="center">
                    Данные отсутствуют
                  </Typography>
                </Box>
              )}
            </>
          )
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose} startIcon={<Cancel />}>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApplicationsByPartnerDialog;
